import { Component, OnDestroy, OnInit } from '@angular/core';
import { Router } from '@angular/router';

import { collection, Firestore, onSnapshot, Unsubscribe } from '@angular/fire/firestore';
import { Functions, httpsCallable, HttpsCallableResult } from '@angular/fire/functions';
import { BehaviorSubject } from 'rxjs';
import { TranslateService } from '@ngx-translate/core';

import { environment } from '../../environments/environment';

@Component({
    selector: 'app-landing',
    templateUrl: `./landing.component${environment.componentAssetExt}.html`,
    styleUrl: `./landing.component${environment.componentAssetExt}.scss`,
    standalone: false
})
export class LandingComponent implements OnInit, OnDestroy {

  acceptedToS = false;
  inProgress = false;
  locale: string;
  selectedTicketId = '';
  tickets$ = new BehaviorSubject([] as any[]);

  private unsubscribe?: Unsubscribe;

  constructor(
    private functions: Functions,
    private firestore: Firestore,
    private router: Router,
    translate: TranslateService) {
      translate.use(translate.getBrowserLang() ?? translate.getFallbackLang() ?? 'en');
      this.locale = translate.getCurrentLang();
    }

  ngOnInit() {
    this.unsubscribe = onSnapshot(
      collection(this.firestore, `instances/${environment.instanceId}/tickets`),
      {
        next: snapshot => {
          const tickets = snapshot
            .docs
            .map(ticketQDS => ticketQDS.data())
            .sort((a, b) => a['sortRank'] - b['sortRank']);
          this.tickets$.next(tickets);
          if (tickets.every(ticket =>
              ticket['id'] !== this.selectedTicketId || !ticket['available']
              )) {
            this.selectedTicketId = '';
          }
        }
      }
    );
  }

  ngOnDestroy() {
    this.unsubscribe?.();
  }

  selectTicketById(ticketId: string) {
    this.selectedTicketId = ticketId;
  }

  async continuePayment() {
    this.inProgress = true;
    try {
      const result = await httpsCallable(this.functions, 'reserveTicket')({
        instanceId: environment.instanceId,
        ticketId: this.selectedTicketId
      }) as HttpsCallableResult<any>;
      this.router.navigate(['customer', result.data.sessionId]);
    }
    catch (e) {
      console.error(e);
      this.inProgress = false;
    }
  }
}
